export let getClientAddresses = async (profileId, setClientAddresses, API_URL, authTokens) => {
    if (profileId === 'new') return
  
    let response = await fetch(`${API_URL}/client/profile/address/${profileId}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authTokens?.access
      }
    })
    let data = await response.json()
    
    setClientAddresses(data)
  }